import React from "react";
import { useDispatch } from "react-redux";
import { openDeleteConfirmModal } from "../../redux/slices/deleteConfirmModal";

export default function DeleteAccount() {
  const dispatch = useDispatch();
  return (
    <div className='flex flex-col w-4/5 sm:w-4/5 lg:w-2/3 m-4'>
      <div className='bg-white flex flex-col p-4 rounded-t-md'>
        <h1 className='text-xl font-bold'>Delete Account</h1>
        <p className='text-xs md:text-sm font-light mt-4 mb-3'>
          Permanently delete your account and all associated data. This action
          cannot be undone, so please proceed with caution.
        </p>
      </div>
      <div className='flex justify-end bg-[#D9D9D9] w-full rounded-b-md px-3 py-2'>
        <button onClick={() => dispatch(openDeleteConfirmModal())} className='bg-[#EC221F] text-xs text-white rounded-md px-3 py-2 hover:bg-[#C41E1F]'>
          Delete Account
        </button>
      </div>
    </div>
  );
}
